<template>
  <v-autocomplete
      :multiple="multiple"
      prepend-icon="store"
      :items="items"
      :item-text="'Nro'"
      :item-value="'Nro'"
      v-model="item"
      :label="$t('afip.factura.labels.PtoVta')"
      :loading="loading"
      :error="hasInputErrors('PtoVta')"
      :error-messages="getInputErrors('PtoVta')"
      color="secondary"
      item-color="secondary"
      :rules="required"
      :style="{width: width}"
  ></v-autocomplete>
</template>

<script>

import {InputErrorsByProps, RequiredRule} from '@dracul/common-frontend'

export default {
  name: "PuntoVentaSettingCombobox",
  mixins: [InputErrorsByProps, RequiredRule],
  props: {
    value: {
      type: [String, Number, Array]
    },
    multiple: {type: Boolean, default: false},
    width: {type: String}
  },
  data() {
    return {
      loading: false
    }
  },
  computed: {
    items(){
      return this.$store.getters.getSettingValue('PuntosDeVenta')
    },
    item: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },
  mounted() {
    this.$store.dispatch('loadSettings')
  },
  methods: {
    validate() {
      return this.$refs.form.validate()
    },


  }
}
</script>

<style scoped>

</style>

